import {types, Instance, SnapshotIn, SnapshotOut} from 'mobx-state-tree';

export interface FullTextSearchResult {
    id: string;
    itemId: string;
    highlight?: {
        content: string
    };
}
export const SearchStore = types.model('SearchStore',
    {
        textInput: types.optional(types.string, ''),
        queryPerformed: types.optional(types.boolean, false),
        textSearchResults: types.optional(types.frozen<FullTextSearchResult[]>(), []),
        isSearching: types.optional(types.boolean, false),
    })
    .views(self => ({
        get isEmpty(): boolean {
            return self.textInput.length === 0;
        },
    }))
    .actions(self => ({
        setTextInput(textInput: string) {
            self.textInput = textInput;
            self.textSearchResults = [];
            self.queryPerformed = false;
        },
        setFullTextSearchResults (searchResults: FullTextSearchResult[]) {
            self.textSearchResults = searchResults;
            self.queryPerformed = true;
            self.isSearching = false;
        },
        setIsSearching (isSearching: boolean) {
            self.isSearching = isSearching;
        },
    }))

export type SearchStoreType = Instance<typeof SearchStore>

export interface SearchStoreSnapshotOut extends SnapshotOut<typeof SearchStore> {}

export interface SearchStoreSnapshotIn extends SnapshotIn<typeof SearchStore> {}
